import script from "./HomeDecoration.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDecoration.vue?vue&type=script&setup=true&lang=js"

import "./HomeDecoration.vue?vue&type=style&index=0&id=239b1440&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239b1440"]])

export default __exports__